import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';

import { ApiError } from 'src/app/interfaces/api';
import { ForgotPassword, IStrapiDocument } from 'src/app/interfaces/strapi';
import { AuthService } from 'src/app/services/auth.service';

import StrapiService from 'src/app/services/strapi.service';
import { UserService } from 'src/app/services/user.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { Regexes } from 'src/app/shared/regexes';
import { NgIf } from '@angular/common';
import { ErrorBlockComponent } from '../../../shared/components/error-block/error-block.component';
import { SuccessBlockComponent } from '../../../shared/components/success-block/success-block.component';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        ErrorBlockComponent,
        SuccessBlockComponent,
    ],
})
export class ForgotPasswordComponent extends PageComponent implements OnInit {
  public override pageData: ForgotPassword = <ForgotPassword>{};

  private cdr = inject(ChangeDetectorRef);

  public email = new UntypedFormControl('', [
    Validators.required.bind(this),
    Validators.email.bind(this),
    Validators.pattern(Regexes.emailRegex),
  ]);

  public formLoading = false;

  public emailSubmitted = false;

  public showForm = true;

  public emailErrorText = '';

  public showEmailError = false;

  private universityCmsId: string | null = null;

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    public readonly formBuilder: UntypedFormBuilder,
    private readonly userService: UserService,
    public readonly authService: AuthService,
    public readonly http: HttpClient
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi
      .getDocumentByUID('forgotten-password', 'forgotten-password', {
        populate: '*',
      })
      .subscribe({
        next: (data: IStrapiDocument<ForgotPassword>) => {
          this.parsePageData(data.data.attributes);
          super.setMetas();
          this.cdr.detectChanges();
        },
      });

    this.universityCmsId = localStorage.getItem('universityCmsID');
  }

  protected override parsePageData(page: ForgotPassword): void {
    super.parsePageData(page);
    this.pageData = page;
  }

  public onSubmit(): void {
    this.emailSubmitted = true;
    this.showEmailError = false;

    if (this.email.invalid) {
      return;
    }
    this.formLoading = true;

    this.userService
      .forgotPassword({
        email: this.email.value as string,
        universityCMSID: this.universityCmsId,
      })
      .subscribe({
        next: (): void => {
          this.showForm = false;
          this.formLoading = false;
          this.cdr.markForCheck()
        },
        error: (e: HttpErrorResponse) => {
          this.formLoading = false;
          const errorObj = <ApiError>e.error;
          this.showEmailError = true;
          if (errorObj.message) {
            this.emailErrorText = errorObj.message;
          }
          this.cdr.markForCheck()
        },
      });
  }
}
